// extracted by mini-css-extract-plugin
export default {"loading_indicator":"loading-indicator_loading_indicator__WBYGU","loading-indicator-dot":"loading-indicator_loading-indicator-dot__0cl6Z"};